export default "__VITE_ASSET__nVujnmZL__"